export const SupportMail = 'support@jobda.im';

export default SupportMail;
